import React from "react";
import { useTranslation } from 'react-i18next';

function createDynamicTag(tagName, props, children) {
  const Tag = tagName;

  return <Tag {...props}>{children}</Tag>;
}
function create_list_ptag(item){
  let tag_data;
  let tag_inner;
  if(item.other_option != undefined){
   let innerItem =  item.other_option ;
  
   innerItem.forEach((itemchild, index) => {
    tag_inner = createDynamicTag(itemchild.tag_name,itemchild.props_data,itemchild.title);
    tag_inner = (<>{itemchild.contain_before}{tag_inner}{itemchild.contain_after}</>)
    tag_data = (<>{tag_data}{tag_inner}</>);
});
  }
 let all_data = item.title;

 return (
  <>
      {all_data} {tag_data}
  </>
);
}
const Termsandcondition = ({details_pargs}) => {
  const { t, i18n } = useTranslation()
  
  return (

    <section className="about-content-section team-more-content policy-contents-section">
            <div className="container">
        <div className="about-content-wrapper d-flex justify-content-between align-items-center">
            <div className="about-content">
             <div className="policy-content">
                <h3>{t("We_Respect_Your_Rights")}</h3>
                <p>{t("CfaN_has_created_this_Privacy_Policy")} <a href="https://cfan.org/">cfan.org.</a></p>
                <div className="privacy-inner-content">
                <p>{t("In_order_to_fully_understand_your_rights_we_encourage")}</p>

                  <ol>
                    <li>{t("Because_we_want_to_demonstrate_our_commitment_to_your_privacy")}</li>
                    <li>{t("What_personally_identifiable_information")}</li>
                    <li>{t("Who_collects_such_information")}</li>
                    <li>{t("How_such_information_is_used")}</li>
                    <li>{t("With_whom_your_information")}</li>
                    <li>{t("What_choices_you_have_regarding_collection")}</li>
                    <li>{t("What_kind_of_security_procedures_are")}</li>
                    <li>{t("How_you_can_correct_any_inaccuracies")}</li>
                  </ol>
                  <p>{t("Questions_regarding_this_statement")} <a href="mailto:singapore@cfan.org.sg">singapore@cfan.org.sg</a> {t("Please_reference_this_Privacy_Policy")}</p>

                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">{t("What_Information_We_Collect")} </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          {t("Our_registration_forms_require_users")}
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">{t("Internet_Protocol_Address")}</button>
                      </h2>
                      <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                         {t("We_collect_an_IP_address_from_all_visitors")}
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">{t("Use_of_Cookies")} </button>
                      </h2>
                      <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          <p>{t("Your_browser_is_probably_set_to_accept_cookies")}</p>

                          <p>{t("CfaN_uses_cookies_for_the_following_purposes")}</p>

                          <p><strong>{t("To_personalise_aspects_of_the_website")}</strong> {t("CfaN_uses_cookies_that_regionalizes_your_content")}</p>

                          <p><strong>{t("To_enable_site_statistics")}</strong> {t("CfaN_uses_Google_Analytics")} <a href="http://www.google.com/intl/en/policies/privacy/" target="_blank">{t("Google_Privacy_Policy")}</a> {t("or")} <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">{t("Googles_Opt_out_tool")}</a></p>

                          <p>{t("Christ_for_all_Nations_allows_Google")}</p>

                          <p><strong>{t("To_enable_sharing_of_articles_on_the_site")}</strong> {t("The_CfaN_site_uses_social_media_sharing_widgets")} <a href="https://www.facebook.com/policy.php" target="_blank">{t("Facebook")}</a>, <a href="https://help.instagram.com/519522125107875?helpref=page_content" target="_blank">{t("Instagram")}</a>, <a href="https://twitter.com/en/privacy" target="_blank">{t("Twitter")}</a> {t("and")} <a href="https://policies.google.com/privacy" target="_blank">{t("Google_Plus")}</a> {t("privacy_policy_for_more_information")}</p>

                          <p><strong>{t("To_enable_advertising_conversion_tracking")}</strong> {t("When_we_run_advertising_campaigns_on_third-party")} <a href="https://www.facebook.com/ads/preferences" target="_blank">{t("here")},</a> {t("Googles_Privacy_Policy_is_found")} <a href="https://policies.google.com/privacy" target="_blank">{t("here")}.</a></p>

                          <p><strong>{t("To_enable_remarketing")}</strong> {t("When_we_run_advertising_campaigns")} <a href="https://www.facebook.com/ads/preferences" target="_blank">{t("here")},</a> {t("Googles_Privacy_Policy_is_found")} <a href="https://policies.google.com/privacy" target="_blank">{t("here")}.</a></p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="true" aria-controls="collapsefour">{t("Security_and_PCI_Compliance")} </button>
                      </h2>
                      <div id="collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          <p> {t("All_information_provided_to_CfaN")} </p>
                          <p> {t("The_CfaN_website_meets_PCI_Compliance")} </p>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="true" aria-controls="collapsefive">{t("Contacting_the_Web_Site")}  </button>
                      </h2>
                      <div id="collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          <p>  {t("If_you_have_any_questions_about_this_Privacy_Policy")}</p>
                          <p><strong>{t("Christ_for_all_Nations_Evangelistic_Ministry")}</strong><br/>
                          27 New Industrial Road<br/>
                          #07-06 Novelty TechPoint<br/>
                          Singapore 536212 </p>
                          <p><strong>Tel:</strong> <a href="tel:+65 6345 9880">+65 6345 9880</a><br/>
                          <strong>Fax:</strong> <a href="tel:+65 6346 2477">+65 6346 2477</a><br/>
                          <strong>WhatsApp:</strong> <a href="https://api.whatsapp.com/send/?phone=6594871923&text&type=phone_number&app_absent=0" target="_blank">+65 9487 1923</a><br/>
                          <strong>Email:</strong> <a href="mailto:singapore@cfan.org.sg">singapore@cfan.org.sg</a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>        
            </div>
         </div>
         </div>
  </section>
  );
};

export default Termsandcondition;